import { useDeviceDetails } from '@/hooks/useDeviceDetails';
import i18n from '@/localisation/i18n';
import useAppStore from '@/store/app';
import { useState } from 'react';
import { Drawer } from 'vaul';

export const InstallAppBanner = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { installEvent } = useAppStore();
  const { os, isStandalone } = useDeviceDetails();

  if (isStandalone) {
    return;
  }

  if (!installEvent && os === 'Android') return null;

  return (
    <>
      <Drawer.Root open={isOpen} onClose={() => setIsOpen(false)}>
        <Drawer.Portal>
          <Drawer.Overlay className="fixed inset-0 bg-black/40" />
          <Drawer.Content className="fixed bottom-0 left-0 right-0 h-fit bg-gray-100 outline-none">
            <div className="bg-main p-4">
              <h3 className="text-xl font-bold">
                {i18n.t('popup.install.title')}
              </h3>
              <div className="mt-5">{i18n.t('popup.install.subtitle')}</div>
              <ul className="steps steps-vertical my-5">
                <li className="step">{i18n.t('popup.install.step.1')}</li>
                <li className="step">{i18n.t('popup.install.step.2')}</li>
                <li className="step">{i18n.t('popup.install.step.3')}</li>
              </ul>
              <div>{i18n.t('popup.install.done')}</div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
      <div
        onClick={async () => {
          if (os === 'IOS') {
            setIsOpen(true);

            return;
          }

          installEvent.prompt();
        }}
        className="block w-full rounded-lg border border-primary bg-card p-6 md:hidden md:h-64 md:min-w-[536px]"
      >
        <div className="flex h-full w-full items-center justify-between">
          <div className="mr-5 flex h-full flex-col">
            <div className="w-full md:min-w-60">
              <h3 className="text-base font-bold md:text-lg">
                {i18n.t('banner.install.title')}
              </h3>
            </div>
            <div className="mt-5 flex md:mt-auto">
              <div className="mr-2 text-xs font-semibold">
                {i18n.t('banner.addClient.link')}
              </div>
              <img
                width={14}
                height={14}
                className="rotate-180"
                src="/icons/back_arrow.svg"
                alt="arrow"
              />
            </div>
          </div>
          <img className="w-24" src="/images/installApp.webp" alt="new user" />
        </div>
      </div>
    </>
  );
};
